import type { IconProps } from '@launchpad-ui/icons';
import { Icon } from '@launchpad-ui/icons';

export function InvertableSnowPlowIcon(props: IconProps) {
  return (
    <Icon {...props}>
      <use href="#app-icon-invertable-snow-plow" />
    </Icon>
  );
}
